// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardCopyController from "./clipboard_copy_controller"
application.register("clipboard-copy", ClipboardCopyController)

import DnsProviderSelectorController from "./dns_provider_selector_controller"
application.register("dns-provider-selector", DnsProviderSelectorController)

import DnsEditorController from "./dns_editor_controller"
application.register("dns-editor", DnsEditorController)

import DnsRecordController from "./dns_record_controller"
application.register("dns-record", DnsRecordController)

import DomainProviderController from "./domain_provider_controller"
application.register("domain-provider", DomainProviderController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import RolePermissionsController from "./role_permissions_controller"
application.register("role-permissions", RolePermissionsController)
